export default __webpack_public_path__ + "static/media/ONE-BUSD.a3f5add9.svg";